import dynamic from 'next/dynamic';
import { TooltipProps } from './Tooltip.types';

const TooltipLazy = dynamic(
  () => import('./Tooltip').then(mod => mod.Tooltip),
  {
    ssr: false,
  }
);

export const Tooltip = (props: TooltipProps) => {
  if (typeof window === 'undefined') {
    return <>{props.children}</>;
  }

  return <TooltipLazy {...props} />;
};
